import { render, staticRenderFns } from "./books-detail.vue?vue&type=template&id=ddc2869c&scoped=true&"
import script from "./books-detail.vue?vue&type=script&lang=js&"
export * from "./books-detail.vue?vue&type=script&lang=js&"
import style0 from "./books-detail.vue?vue&type=style&index=0&id=ddc2869c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc2869c",
  null
  
)

export default component.exports